<template>
  <div>
    <!-- Footer Start -->
    <footer class="bg-footer">
      <div class="container pt-5">
        <div class="row">
          <!-- Company Info -->
          <div class="col-lg-4 col-md-6 mb-4 mb-md-0">
            <img src="../../assets/svgs/icon.svg" alt="TafiCloud" class="footer-logo mb-4" height="40">
            <p class="text-muted mb-4">Smart cloud storage with AI-driven search and easy SDK integration for developers and businesses.</p>
            <ul class="list-unstyled social-icon mb-0">
              <li class="list-inline-item"><a href="#" class="rounded"><i class="uil uil-github"></i></a></li>
              <li class="list-inline-item"><a href="#" class="rounded"><i class="uil uil-twitter"></i></a></li>
              <li class="list-inline-item"><a href="#" class="rounded"><i class="uil uil-linkedin"></i></a></li>
            </ul>
          </div>

          <!-- Quick Links -->
          <div class="col-lg-2 col-md-6 mb-4 mb-md-0">
            <h5 class="footer-head mb-3">Product</h5>
            <ul class="list-unstyled footer-list">
              <li><a href="https://dashboard.taficloud.com/" target="_blank"><i class="uil uil-angle-right-b me-1"></i> Dashboard</a></li>
              <li><a href="https://docs.taficloud.com" target="_blank"><i class="uil uil-angle-right-b me-1"></i> Documentation</a></li>
              <li><a href="/#pricing"><i class="uil uil-angle-right-b me-1"></i> Pricing</a></li>
              <li><a href="#features"><i class="uil uil-angle-right-b me-1"></i> Features</a></li>
            </ul>
          </div>

          <!-- Resources -->
          <div class="col-lg-2 col-md-6 mb-4 mb-md-0">
            <h5 class="footer-head mb-3">Resources</h5>
            <ul class="list-unstyled footer-list">
              <li><a href="#"><i class="uil uil-angle-right-b me-1"></i> Blog</a></li>
              <li><a href="https://docs.taficloud.com" target="_blank"><i class="uil uil-angle-right-b me-1"></i> SDK Examples</a></li>
              <li><a href="https://docs.taficloud.com/api-reference/introduction" target="_blank"><i class="uil uil-angle-right-b me-1"></i> API Reference</a></li>
            </ul>
          </div>

          <!-- Company -->
          <div class="col-lg-2 col-md-6 mb-4 mb-md-0">
            <h5 class="footer-head mb-3">Company</h5>
            <ul class="list-unstyled footer-list">
              <li><a href="/contact"><i class="uil uil-angle-right-b me-1"></i> Contact Us</a></li>
              <li><router-link to="/privacy-policy"><i class="uil uil-angle-right-b me-1"></i> Privacy Policy</router-link></li>
              <li><router-link to="/terms-of-service"><i class="uil uil-angle-right-b me-1"></i> Terms of Service</router-link></li>
            </ul>
          </div>

          <!-- Newsletter -->
          <div class="col-lg-2 col-md-6">
            <h5 class="footer-head mb-3">Get Started</h5>
            <p class="text-muted mb-3">Start your free trial today!</p>
            <a href="https://dashboard.taficloud.com/" class="btn btn-primary">Sign Up Free</a>
          </div>
        </div>
      </div>

      <div class="footer-py-30 footer-bar">
        <div class="container text-center">
          <div class="row align-items-center">
            <div class="col-sm-12">
              <div class="text-center">
                <p class="mb-0">© {{ new Date().getFullYear() }} TafiCloud. All rights reserved.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
    <!-- Footer End -->
  </div>
</template>

<script>
export default {
  name: "FooterTafiCloud"
}
</script>

<style lang="scss" scoped>
.footer-logo {
  max-width: 160px;
}

.footer-head {
  font-weight: 600;
  color: #979393;
}

.footer-list li {
  margin-bottom: 10px;
}

.footer-list a {
  color: #6c757d;
  transition: all 0.3s ease;
  text-decoration: none;
}

.footer-list a:hover {
  color: var(--bs-primary);
  padding-left: 5px;
}

.social-icon li a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  width: 36px;
  background-color: rgba(var(--bs-primary-rgb), 0.1);
  color: var(--bs-primary);
  transition: all 0.3s ease;
  border-radius: 50%;
}

.social-icon li a:hover {
  background-color: var(--bs-primary);
  color: white;
}
</style>